package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.file.ui.components.Attachments
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceEvent
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceNavigation
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceState
import com.essntl.features.itinerary.ui.edit_itinerary_service.EditItineraryServiceValidation
import com.essntl.uikit.components.expandable.ExpandableTabs
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import core.config.FeatureConfig

@Composable
fun EditItineraryServiceColumn(
    category: CategoryModel?,
    validation: EditItineraryServiceValidation,
    state: EditItineraryServiceState,
    onEvent: (EditItineraryServiceEvent) -> Unit,
    onNavigation: (EditItineraryServiceNavigation) -> Unit,
    contactState: ContactState,
    contactEvent: (ContactEvent) -> Unit,
) {
    val tabList = remember(FeatureConfig.hasWhatsapp) {
        if (FeatureConfig.hasWhatsapp)
            listOf(
                "Notes & Tasks",
                "Attachments",
                "Messages",
            )
        else
            listOf(
                "Notes & Tasks",
                "Attachments",
            )
    }

    Column(
        modifier = Modifier
            .background(
                color = MaterialTheme.esColorScheme.bgPrimary,
            )
            .fillMaxSize(),
    ) {
        state.itineraryService.value.let { itineraryService ->
            LazyColumn(
                verticalArrangement = Arrangement.spacedBy(1f.spacing),
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)
                    .clip(
                        RoundedCornerShape(
                            topStart = 24.dp,
                            topEnd = 24.dp,
                        ),
                    ),
            ) {
                item {
                    ExpandableTabs(
                        tabList = tabList,
                        id = itineraryService.id,
                        modifier = Modifier
                            .background(
                                color = MaterialTheme.esColorScheme.bgSecondary,
                                shape = RoundedCornerShape(EsConstants.RoundedCornerSize),
                            )
                            .fillMaxWidth(),
                    ) { index ->
                        when (index) {
                            0 -> {
                                EditItineraryServiceNotesTasks(
                                    onEvent = onEvent,
                                    onNavigation = onNavigation,
                                    itineraryService = itineraryService,
                                    allTasks = state.getAllItineraryServiceTask,
                                )
                            }

                            1 -> {
                                Attachments(
                                    state = state.fileState,
                                    profiles = state.getAllProfile.data.orEmpty(),
                                    currentProfile = state.getCurrentProfile.data,
                                    onAddAttachments = {
                                        onEvent(
                                            EditItineraryServiceEvent.AddAttachments(it),
                                        )
                                    },
                                    onDeleteAttachment = {
                                        onEvent(
                                            EditItineraryServiceEvent.DeleteAttachment(it),
                                        )
                                    },
                                )
                            }

                            2 -> {
                                EditItineraryServiceMessages(
                                    state = state,
                                )
                            }
                        }
                    }
                }

                item {
                    EditItineraryServiceDetails(
                        state = state,
                        category = category,
                        validation = validation,
                        itineraryService = itineraryService,
                        onItineraryServiceChange = {
                            onEvent(
                                EditItineraryServiceEvent.UpdateItineraryServiceFields(
                                    itineraryService = it,
                                ),
                            )
                        },
                    )
                }

                item {
                    EditItineraryServiceDescription(
                        itineraryService = itineraryService,
                        state = state,
                        onEvent = onEvent,
                        onNavigation = onNavigation,
                        contactState = contactState,
                        contactEvent = contactEvent,
                    )
                }
            }
        }
    }
}